var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.166748 2.50065C0.166748 2.13246 0.465225 1.83398 0.833415 1.83398H19.1667C19.5349 1.83398 19.8334 2.13246 19.8334 2.50065V6.66732C19.8334 7.03551 19.5349 7.33398 19.1667 7.33398H18.1667V17.5002C18.1667 17.8684 17.8682 18.1668 17.5 18.1668H2.50002C2.13183 18.1668 1.83335 17.8684 1.83335 17.5002V7.33398H0.833415C0.465225 7.33398 0.166748 7.03551 0.166748 6.66732V2.50065ZM17.5197 6.00045C17.5217 6.00051 17.5237 6.00057 17.5258 6.00065H18.5001V3.16732H1.50008V6.00065H2.47427C2.48282 6.00033 2.4914 6.00016 2.50002 6.00016C2.50864 6.00016 2.51723 6.00033 2.52577 6.00065H17.4743C17.4828 6.00033 17.4914 6.00016 17.5 6.00016C17.5066 6.00016 17.5131 6.00026 17.5197 6.00045ZM16.8334 7.33398H3.16669V16.8335H16.8334V7.33398ZM8.33325 9.33382C7.96506 9.33382 7.66659 9.6323 7.66659 10.0005C7.66659 10.3687 7.96506 10.6672 8.33325 10.6672H11.6666C12.0348 10.6672 12.3333 10.3687 12.3333 10.0005C12.3333 9.6323 12.0348 9.33382 11.6666 9.33382H8.33325Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.e1705d9f428b5df4ae004f9615216fb6.svg";
export { ForwardRef as ReactComponent };